import request from './request'

// 获取动作编号列表
export function getActionNumList (data) {
  return request.get('en/action/num/list', data)
}
// 新增动作编号
export function addActionNum (data) {
  return request.post('en/action/num/add', data)
}
// 删除动作编号
export function delActionNum (data) {
  return request.post('en/action/num/delete', data)
}
// 获取联动条件列表
export function getApsList (data) {
  return request.get('en/aps/list', data)
}
// 新增联动条件
export function addAps (data) {
  return request.post('en/aps/add', data)
}
// 删除联动条件
export function delAps (data) {
  return request.post('en/aps/delete', data)
}
// 修改联动条件
export function updateAps (data) {
  return request.post('en/aps/update', data)
}
// 获取动作列表
export function getApaList (data) {
  return request.get('en/apa/list', data)
}
// 新增动作条件
export function addApa (data) {
  return request.post('en/apa/add', data)
}
// 删除动作条件
export function delApa (data) {
  return request.post('en/apa/delete', data)
}
// 修改动作条件
export function updateApa (data) {
  return request.post('en/apa/update', data)
}
//批量保存触发条件
export function saveAllAps (data) {
  return request.post('en/aps/save/all', data)
}
//批量保存触发条件
export function saveAllApa (data) {
  return request.post('en/apa/save/all', data)
}
